import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const IconFacebook = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_facebook)">
        <path
          d="M0 14.7693V1.23077C0 0.904349 0.12967 0.591298 0.360483 0.360483C0.591298 0.12967 0.904349 0 1.23077 0H14.7693C15.0957 0 15.4087 0.12967 15.6395 0.360483C15.8703 0.591298 16 0.904349 16 1.23077V14.7693C16 15.0957 15.8703 15.4087 15.6395 15.6395C15.4087 15.8703 15.0957 16 14.7693 16H11.0769V10.1662H11.9507C12.1499 10.1662 12.3408 10.0871 12.4816 9.94626C12.6224 9.80546 12.7015 9.6145 12.7015 9.41538V8.46769C12.7015 8.3691 12.6822 8.27147 12.6443 8.18039C12.6066 8.0893 12.5513 8.00654 12.4816 7.93682C12.4119 7.86711 12.3291 7.81181 12.2381 7.77407C12.147 7.73634 12.0494 7.71693 11.9507 7.71693H11.1262V6.56C11.1262 5.52615 11.5938 5.52615 12.0615 5.52615H12.6646C12.7637 5.53023 12.8624 5.5125 12.9538 5.47423C13.0453 5.43594 13.1272 5.37805 13.1938 5.30462C13.2654 5.23653 13.3219 5.15433 13.3601 5.06323C13.3983 4.97214 13.417 4.87413 13.4154 4.77538V3.86462C13.4186 3.76439 13.4022 3.6645 13.3669 3.57066C13.3314 3.47682 13.2779 3.39087 13.2094 3.31771C13.1408 3.24456 13.0585 3.18565 12.9671 3.14432C12.8758 3.10301 12.7771 3.0801 12.6769 3.07693H11.2615C10.8485 3.06139 10.4371 3.1357 10.0556 3.29472C9.67418 3.45373 9.33178 3.69365 9.05209 3.99791C8.77241 4.30217 8.5621 4.66352 8.4357 5.05699C8.3093 5.45048 8.26983 5.8667 8.32 6.27693V7.71693H7.53231C7.43269 7.71529 7.33374 7.73351 7.24122 7.7705C7.14871 7.8075 7.06448 7.86254 6.99346 7.93242C6.92243 8.0023 6.86603 8.08561 6.82753 8.17751C6.78904 8.26942 6.76922 8.36806 6.76923 8.46769V9.41538C6.76922 9.51502 6.78904 9.61367 6.82753 9.70557C6.86603 9.79746 6.92243 9.88078 6.99346 9.95066C7.06448 10.0205 7.14871 10.0756 7.24122 10.1126C7.33374 10.1496 7.43269 10.1678 7.53231 10.1662H8.32V16H1.23077C0.904349 16 0.591298 15.8703 0.360483 15.6395C0.12967 15.4087 0 15.0957 0 14.7693Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_facebook">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

IconFacebook.defaultProps = {
  className: null,
  rootClassName: null,
};

IconFacebook.propTypes = {
  className: PropTypes.string,
  rootClassName: PropTypes.string,
};

export default IconFacebook;
